import React, { useEffect } from "react";

export default function PageHeader({ title, subtitle, action, testid }) {
  // Branded browser-tab title for every dashboard page using this header.
  useEffect(() => {
    if (typeof title === "string" && title.trim()) {
      document.title = `Findloop | ${title}`;
    }
    return () => { document.title = "Findloop — Objets perdus & retrouvés"; };
  }, [title]);

  return (
    <div className="flex items-start justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-extrabold text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1 text-sm md:text-base">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
